interface Props {
  unit: string;
}

const UnitLabel = (props: Props): JSX.Element => {
  return (
    <span className="notranslate" lang="zxx" translate="no">
      {props.unit}
    </span>
  );
};

export default UnitLabel;
